import { ErrorWithContext } from '@fabric-ui/utils';

// eslint-disable-next-line fabric-ui/no-class
export class WidgetError extends ErrorWithContext {
  name = 'WidgetError';
}

export const isWidgetError = (error: Error): error is WidgetError => error instanceof WidgetError && error.name === 'WidgetError';
